module.exports = __webpack_public_path__ + "fonts/AlteDIN1451Mittelschrift.c461fca0.woff";